export default () => {
  $('.btn-dropdown').on('click', (e) => {
    const $target = $(e.target);
    const $dropdown = $target.closest('.dropdown');

    $dropdown.toggleClass('is-active');
  });
};